import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  AccordionSummary,
  CardContent,
  Stack,
  Typography
} from '@mui/material';

import { useStyles } from '@/features/DevicesTable';
import { getMostRecentLastSeen } from '@/features/SourceCreate/DataProvider/DataProvider.service';
import SOURCE_TYPE from '@/features/SourceCreate/SourceCreate.constants';

import SourceCard from '../SourceCard/SourceCard';
import {
  Accordion,
  AccordionDetails
} from '../SourceStatusCard/Accordion.styled';
import type { MicrosoftProvidersCardProps } from './ViewDataProviders.types';

// Microsoft providers displayed in the source detail pane
const MicrosoftProviders = (props: MicrosoftProvidersCardProps) => {
  const { items } = props;
  const { classes } = useStyles();

  // Set most recent last seen for Microsoft source
  const msDataProviders = items.filter(
    (item) => item.source_type_id !== SOURCE_TYPE.MICROSOFT
  );
  const mostRecentLastSeen = getMostRecentLastSeen(msDataProviders);
  const msSource = items.find(
    (item) => item.source_type_id === SOURCE_TYPE.MICROSOFT
  );

  if (msSource) {
    msSource.last_seen = mostRecentLastSeen;
  }

  return (
    <CardContent
      style={{ overflow: 'auto' }}
      className={classes.cardContentMicrosoft}
    >
      <Stack
        direction="row"
        sx={{ alignItems: 'center', justifyContent: 'space-between' }}
        spacing={1}
      >
        {items.length > 0 && (
          <SourceCard key={items[0]?.source_uid} item={items[0]} />
        )}
      </Stack>

      {/* Status Information */}
      <Stack className={classes.statusInfoAccordionMicrosoft}>
        {items
          ?.filter((item) => item.source_type_id !== SOURCE_TYPE.MICROSOFT)
          .map((item) => (
            <Accordion key={item.source_uid}>
              <AccordionSummary
                expandIcon={
                  <FontAwesomeIcon
                    icon={faChevronDown}
                    style={{ fontSize: '0.9rem' }}
                  />
                }
                aria-controls="status-info"
                id="status-info-header"
              >
                <Typography
                  sx={{ fontWeight: 700 }}
                  variant="body1"
                  color="primary"
                  component="span"
                >
                  {item?.source_type_id === SOURCE_TYPE.MICROSOFT_ENTRA_ID
                    ? `${item?.source_type?.name}-${
                        item?.connection_inputs?.name
                      }`
                    : item?.source_type?.name}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <SourceCard key={item?.source_uid} item={item} />
              </AccordionDetails>
            </Accordion>
          ))}
      </Stack>
    </CardContent>
  );
};

export default MicrosoftProviders;
